//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register";

//LOGIN
export const POST_LOGIN = "/auth/jwt/create/";
export const POST_TOKEN_REFRESH = "/auth/jwt/refresh/";

//PERMISSIONS
export const GET_PERMISSIONS = "/permissions/";

//META COUNTRIES
export const GET_META_COUNTRIES = "/meta/countries/"

//  GET_NOTIFICATIONS,
export const NOTIFICATIONS = "/notifications/";

//GROUPS
export const GROUPS = "/groups/";

export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/post-fake-profile";

//CAMPAIGNS LIST
export const GET_CAMPAIGNS_LIST = "/campaigns/";
//CAMPAIGNS WAREHOUSE VK LIST
export const API_WAREHOUSE_INTEGRATION_VK_CAMPAIGN = "/warehouse/integration-vk-campaign/";
//BANNERS WAREHOUSE VK LIST
export const API_WAREHOUSE_INTEGRATION_VK_BANNER = "/warehouse/integration-vk-banners/";
//ADVERTISERS WAREHOUSE TIKTOK LIST
export const API_WAREHOUSE_INTEGRATION_TIKTOK_ADVERTISERS = "/warehouse/integration-tiktok-advertisers/";
//AGENCIES WAREHOUSE MT LIST
export const API_WAREHOUSE_INTEGRATION_MT_AGENCIES = "/warehouse/integration-mytarget-agencies/";
//BANNERS WAREHOUSE MT LIST
export const API_WAREHOUSE_INTEGRATION_MT_BANNERS = "/warehouse/integration-mytarget-banners/";
//CAMPAIGNS WAREHOUSE MT LIST
export const API_WAREHOUSE_INTEGRATION_MT_CAMPAIGNS = "/warehouse/integration-mytarget-campaigns/";
//CHECK_CAMPAIGN_NAMES
export const API_WAREHOUSE_CHECK_CAMPAIGN_NAMES = "/warehouse/check-campaign-names"
//INTEGRATION CABINET LIMITS
export const API_WAREHOUSE_CABINET_LIMITS = "/warehouse/integration-cabinet-limits/"
//CAMPAIGNS OFFER TYPES
export const GET_CAMPAIGNS_OFFER_TYPE = "/campaigns-offer-types/";
//CAMPAIGNS MEDIA BUYER
export const GET_CAMPAIGNS_MEDIA_BUYER = "/campaigns-media-buyer/";
//CAMPAIGNS ADVERTISING ACCOUNTS
export const GET_CAMPAIGNS_ADVERTISING_ACCOUNT = "/campaigns-cabinets/";
export const WAREHOUSE_LOAD_PLATFORM_CABINETS = "/warehouse/load-platform-cabinets";
//CAMPAIGNS CASHBACKS
export const GET_CAMPAIGNS_CASHBACK = "/cashbacks/";
// POSITIONS
export const POSITION = "/positions/";
//OFFER
export const GET_OFFER_DATA = "/offers/offer_data/";
export const OFFERS_API = "/offers/";
export const OFFERS_STATUS_API = "/offers/change_status/";
export const OFFERS_WITH_REGULAR_MARCHING = '/warehouse/offer-with-regular-matching/data/'

//EVENT
export const EVENTS_API = "/events/";

//INVOICES
export const INVOICES_API = "/invoices/";
export const INVOICES_ITEMS_API = "/invoices_items/";
export const INVOICES_TEMPLATES_API = "/invoice_templates/";

//PLAN
export const PLAN_API = "/manager/plans/";
export const PLAN_TOTAL_PLAN = "/manager/plans/total_plan/"
export const PLAN_TOTAL_PROFIT = "/manager/plans/total_profit/"
export const PLAN_BULK_API = "/manager/plans/bulk";
export const PLAN_GROUPS = "/manager/plan-groups/"
export const PLAN_GROUPS_BULK = "/manager/plan-groups/bulk"
export const PLAN_PAYOUT = "/manager/payout-conditions/bulk"
export const PLAN_CASHBACK = "/manager/cashback-plan/"
export const PLAN_CASHBACK_BULK = "/manager/cashback-plan/bulk"
export const PLAN_CUSTOM_BY_DAY_BULK = "/manager/custom-profit-by-days/bulk"
export const PLAN_BY_DAY = "/manager/plans/profit_by_day/"
export const PLAN_PROFIT_WIDGET = "/manager/plans/profit_widgets/"
export const MEDIA_BUYER_PLAN_PAYOUT = "/media-buyer/payout-conditions/bulk"
export const PLAN_MANAGERS_WITH_STATS = "/manager/plans/users_with_stat/"
export const PLAN_OFFERS_WITH_STATS = "/manager/plans/offers_with_stat/"


// CUSTOM PROFIT
export const PLAN_CUSTOM_PROFIT = "/manager/custom-profit/"

//TRACKER
export const TRACKERS_API = "/trackers/";

//MEDIA BUYERS BUDGET
export const GET_MEDIA_BUYER_BUDGETS = "/media-buyer-budgets/";
//MEDIA BUYERS PLANS
export const PLANS_OFFERS = "/plans/offers/";
export const PLANS_MEDIA_BUYERS = "/plans/media-buyers/";
export const MEDIA_BUYERS = "/media-buyers/";
export const PLANS_MEDIA_BUYERS_PROFIT = "/media-buyers/plans/profit"
// export const PLANS_MEDIA_BUYERS_PROFIT = "/plans/media-buyers/profit"

//APPLICATIONS
export const META_AD_PLATFORMS = "/meta/ad-platforms/";
export const META_TRACKING_PLATFORMS = "/meta/tracking-platforms/";
export const GET_APPLICATIONS = "/applications/";
export const GET_APP_DATA = "/applications/app_data/";

//CAMPAIGNS FORMAT LIST
export const GET_CAMPAIGN_FORMAT_LIST = "/campaigns-formats/";

//CAMPAIGNS STATUSES LIST
export const GET_CAMPAIGN_STATUSES = "/campaigns-statuses/";

//CAMPAIGNS SOURCES LIST
export const GET_CAMPAIGN_SOURCES = "/campaigns-sources/";

//CAMPAIGNS DIRECTION LIST
export const GET_CAMPAIGN_DIRECTION_TYPE = "/campaigns-direction-type/";

//CAMPAIGNS DEVICE LIST
export const GET_CAMPAIGN_DEVICE_TYPE = "/campaigns-device-types/";

//CAMPAIGNS CUSTOM NAMES LIST
export const GET_CAMPAIGN_CUSTOM_NAMES = "/campaigns-custom-names/";

//REPORTING
export const API_REPORT = "/reporting/";
export const API_REPORT_QUALITY = "/reporting/quality/";
export const API_REPORT_TOPMANAGEMENT = "/reporting/topmanagement/";
export const API_REPORT_PAYMENT_COST = "/reporting/payment-cost/inspections/"
export const API_REQUEST_DATA_UPDATE = "/reporting/quality/stats/request_data_update/"
export const API_REPORT_EVENTS_STATS = "/reporting/quality-events/stats/"

//CLIENTS LIST
export const API_CLIENTS = "/clients/";
export const API_CLIENT_DOCUMENTS = "/client_documents/";
export const API_WAREHOUSE_INTEGRATION_VK_CLIENTS = "/warehouse/integration-vk-clients/";


// CONTRACTS LIST
export const API_CONTRACTS = "/contracts/";

// SERVICE PROVIDERS
export const API_SERVICE_PROVIDERS = "/service-providers/";

// LEGAL ENTITY LIST
export const API_LEGAL_ENTITY = "/inner-contracts/";

// COHORT REPORT
export const API_COHORT_REPORT = "/reporting/quality_cohort/stats";
export const API_COHORT_REPORT_OPTIONS = '/reporting/quality_cohort/stats/options/'
export const API_COHORT_REPORT_PARAMS_FOR_FRAGMENTATION = '/reporting/quality_cohort/stats/params_for_fragmentation/'
export const API_COHORT_REPORT_FILTER_DATA = '/reporting/quality_cohort/stats/filter_data/'
export const API_COHORT_REPORT_TEMPLATES = "/reporting/templates/quality_cohort/";


// META VARIABLES
export const META_VARIABLES = "/meta/variables/";

// PAYMENT FORMULAS
export const PAYMENT_FORMULAS = "/payment-formulas/";

//PRODUCTS
export const GET_PRODUCTS = "/products";
export const GET_PRODUCTS_DETAIL = "/product";
export const ADD_NEW_PROJECT = "/add/product";
export const UPDATE_PROJECT = "/update/product";
export const DELETE_PROJECT = "/delete/product";

//CALENDER
export const GET_EVENTS = "/events/";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";
export const GET_CATEGORIES = "/categories";

//CHATS
export const GET_CHATS = "/chats";
export const GET_GROUPS = "/groups";
export const GET_CONTACTS = "/contacts";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "/add/messages";

//ORDERS
export const GET_ORDERS = "/orders";
export const ADD_NEW_ORDER = "/add/order";
export const UPDATE_ORDER = "/update/order";
export const DELETE_ORDER = "/delete/order";

//CART DATA
export const GET_CART_DATA = "/cart";

//CUSTOMERS
export const GET_CUSTOMERS = "/customers";
export const ADD_NEW_CUSTOMER = "/add/customer";
export const UPDATE_CUSTOMER = "/update/customer";
export const DELETE_CUSTOMER = "/delete/customer";

//SHOPS
export const GET_SHOPS = "/shops";

//CRYPTO
export const GET_WALLET = "/wallet";
export const GET_CRYPTO_ORDERS = "/crypto/orders";

//INVOICES
export const GET_INVOICES = "/invoices";
export const GET_INVOICE_DETAIL = "/invoice";

//PROJECTS
export const GET_PROJECTS = "/projects";
export const GET_PROJECT_DETAIL = "/project";

//TASKS
export const GET_TASKS = "/tasks";

//USERS
export const GET_USERS = "/users/";
export const GET_USER_PROFILE = "/user";
export const ADD_NEW_USER = "/add/user";
export const UPDATE_USER = "/update/user";
export const DELETE_USER = "/delete/user";

//Mails
export const GET_INBOX_MAILS = "/inboxmails";
export const ADD_NEW_INBOX_MAIL = "/add/inboxmail";
export const DELETE_INBOX_MAIL = "/delete/inboxmail";

//starred mail
export const GET_STARRED_MAILS = "/starredmails";

//important mails
export const GET_IMPORTANT_MAILS = "/importantmails";

//Draft mail
export const GET_DRAFT_MAILS = "/draftmails";

//Send mail
export const GET_SENT_MAILS = "/sentmails";

//Trash mail
export const GET_TRASH_MAILS = "/trashmails";

//dashboard charts data
export const GET_WEEKLY_DATA = "/weekly-data";
export const GET_YEARLY_DATA = "/yearly-data";
export const GET_MONTHLY_DATA = "/monthly-data";

export const TOP_SELLING_DATA = "/top-selling-data";

export const GET_EARNING_DATA = "/earning-charts-data";

// meta
export const GET_COUNTRIES = "/meta/countries/";

// mapper
export const API_MAPPER = "/mapper/";

// salary bonuses
export const API_SALARY_BONUSES = "/salary-bonuses/";

// bank details
export const API_BANK_DETAILS = "/bank-details/";

// bank-correspondents
export const API_BANK_CORRESPONDENTS = "/bank-correspondents/";

// bank-uploading
export const API_BANK_UPLOADING = "/bank-uploading/";

// transactions
export const API_TRANSACTIONS = "/transactions/"

// user actions
export const GET_USERS_ACTIONS = "/user-actions/"

// user-payout-conditions
export const USER_PAYOUT_CONDITIONS = "/user-payout-conditions/"

// user-salary-conditions
export const USER_SALARY_CONDITIONS = "/user-salary-conditions/"